module.exports = __webpack_public_path__ + "img/203.fafad3d7.png";